/* Original Wiken motion; progressive enhancement, no external runtime or scroll capture. */
(() => {
  const scope = document.querySelector('body.wiken-atelier');
  if (!scope || scope.dataset.atReady) return;
  scope.dataset.atReady = 'true';
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  let frame = 0;
  let parallax = null;
  const reveal = () => {
    if (observer) observer.disconnect();
    scope.classList.remove('at-motion');
    scope.querySelectorAll('[data-at-reveal],[data-at-line]').forEach(element => element.classList.remove('at-pending', 'at-in-view'));
    if (preference.matches || !('IntersectionObserver' in window)) return;
    scope.classList.add('at-motion');
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('at-in-view');
        entry.target.classList.remove('at-pending');
        observer.unobserve(entry.target);
      });
    }, {threshold: 0.08, rootMargin: '0px 0px -24px 0px'});
    scope.querySelectorAll('[data-at-reveal],[data-at-line]').forEach(element => {
      element.classList.add('at-pending');
      observer.observe(element);
    });
  };
  const updateImage = () => {
    frame = 0;
    if (!parallax) return;
    const y = preference.matches || innerWidth < 990 ? 0 : Math.min(window.scrollY * 0.055, 28);
    parallax.style.setProperty('--at-pan', `${y}px`);
  };
  const onScroll = () => {
    if (!frame && parallax && window.scrollY < 1400) frame = requestAnimationFrame(updateImage);
  };
  const init = () => {
    reveal();
    parallax = scope.querySelector('[data-at-parallax]');
    updateImage();
  };
  init();
  window.addEventListener('scroll', onScroll, {passive: true});
  preference.addEventListener('change', init);
  document.addEventListener('shopify:section:load', init);
})();
